// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"EmployeeDashboardComponent_hidescrollbar__00y9-"};